import React from 'react'
import ExpertChatButton from '#src/components/ExpertChatButton'
import { Avatar, Button } from '@deal/components'
import { generateCreateUrlFromCategory } from '#src/services/path'
import { Link } from 'react-router-dom'
import { ProductExpertFragment, ExpertCuratedItemNoteFragment } from '#src/generated/graphql'
import IconChat from './icon-chat.svg'
import styles from './styles.css'

interface NoteProps {
  note: ExpertCuratedItemNoteFragment
  maybeSellableExpert?: ProductExpertFragment | null
  categorySlug: string
}

const Note: React.SFC<NoteProps> = ({ note, maybeSellableExpert, categorySlug }) => {
  let noteExpert = note.createdBy
  if (maybeSellableExpert) {
    noteExpert = maybeSellableExpert
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.expert}>
        <Avatar
          name={noteExpert.displayName}
          src={
            noteExpert.expertProfile && noteExpert.expertProfile.profilePhoto
              ? noteExpert.expertProfile.profilePhoto.url
              : undefined
          }
          size={44}
        />
        <div className={styles.expertMetadata}>
          <div className={styles.expertName}>{noteExpert.displayName}</div>
          {noteExpert.expertProfile && (
            <div className={styles.expertTitle}>{noteExpert.expertProfile.headline}</div>
          )}
        </div>
      </div>
      <div className={styles.header}>
        Why <span className={styles.firstName}>{noteExpert.shortName}</span> likes this product
      </div>
      <div className={styles.body}>{note.text}</div>
      <div className={styles.actions}>
        <ExpertChatButton
          guestLocation={generateCreateUrlFromCategory({
            maybeCategorySlug: categorySlug,
            sourceKey: 'product-details-expert-note',
            pathIntent: 'request'
          })}
          expertId={noteExpert.id}
        >
          {(startExpertConsumerConversation, loading) => (
            <Button
              disabled={loading}
              variant="contrast"
              onClick={() =>
                startExpertConsumerConversation ? startExpertConsumerConversation() : null
              }
              className={styles.chatButton}
            >
              <IconChat className={styles.chatIcon} />
              <p className={styles.chatButtonCopy}>Talk to&nbsp;{noteExpert.shortName}</p>
            </Button>
          )}
        </ExpertChatButton>

        <Link
          to={`/experts/${noteExpert.vanityId || noteExpert.id}`}
          className={styles.viewProfileLink}
        >
          <Button variant="contrast-outline" className={styles.viewProfile}>
            <p>View&nbsp;{noteExpert.shortName}'s Profile</p>
          </Button>
        </Link>
      </div>
    </div>
  )
}

export default Note
